
import React from "react";
import ReactJson from 'react-json-view';

import {ItemsContainer} from './RenderItems';
import {RenderItem} from './RenderItem';

import { useStateValue } from "./state";
import {Streams} from "./Streams";

export const TableDetailsContainer = () => {
    const [{connection}, ] = useStateValue();
    const [{operation}, ] = useStateValue();

    const [{metadata}, ] = useStateValue();


    const [, dispatch] = useStateValue();
    let KeySchema;
    // let pkName;
    let skName;

    if(metadata && metadata.Table) {
        KeySchema = metadata.Table.KeySchema;

        // pkName = KeySchema[0].AttributeName;
        skName = KeySchema[1] ? KeySchema[1].AttributeName : null;

    }
    let GSIs = [];
    const t = metadata.Table || null;
    if(t && t.GlobalSecondaryIndexes) {
        GSIs = t.GlobalSecondaryIndexes;
    }

    const cn = 'btnDefault';
    const cn2 = 'btnSelected';

    const bannerBar = (
        <>
            <table className='dataTable'>
                <tbody>
                <tr>
                    <td className='attrTDlight'>
                        <button className={operation.index ? cn : cn2}
                                onClick={ () => {

                                    const op = {target: operation.target, index:null, action:null};

                                    dispatch({"type":"setOperation", "operation": op});

                                    }
                                }
                        >{operation.target}</button>

                        <br/>

                        {GSIs.map((item, index) => {

                            return (<React.Fragment key={index}>
                                <button className={operation.index === item.IndexName ? cn2 : cn} key={index}
                                            onClick={ () => {

                                                // alert('you clicked ' + item.IndexName);

                                                const op = {target: operation.target, index:item.IndexName, action:null};

                                                dispatch({"type":"setOperation", "operation": op});

                                                }
                                            }>{item.IndexName}</button><br/></React.Fragment>);

                        })}

                    </td><td className='attrTD'>

                    {/*<button className={cn}*/}
                        {/*onClick={*/}
                            {/*() => {*/}
                                {/*dispatch({type: 'appendLog', newMsg: 'metadata for : ' + operation.target});*/}

                                {/*const op = {target: operation.target, index:operation.index, action:null};*/}

                                {/*dispatch({"type":"setOperation", "operation": op});*/}

                            {/*}*/}
                        {/*} >METADATA</button> &nbsp;*/}

                    <button className={cn}
                        onClick={
                            () => {

                                const op = {target: operation.target,index:operation.index, action:'scan'};

                                dispatch({"type":"setOperation", "operation": op});

                            }
                        } >SCAN</button> &nbsp;

                    {operation.index ? null : (<button className={cn}
                        onClick={
                            () => {

                                const op = {target: operation.target,action:'get'};

                                dispatch({"type":"setOperation", "operation": op});

                            }
                        } >GET-ITEM</button> )
                     }

                    &nbsp;

                   <button className={cn}
                            onClick={
                                () => {

                                    const op = {target: operation.target, index:operation.index, action: 'query'};

                                    dispatch({"type": "setOperation", "operation": op});

                                }
                            }>QUERY</button>


                    &nbsp;

                    <button className={cn}
                        onClick={
                            () => {

                                const op = {target: operation.target,action:'streams'};

                                dispatch({"type":"setOperation", "operation": op});
                            }
                        } >STREAMS</button>

                </td>

                </tr>


                </tbody>
            </table>
        <br/>

        </>
    );

    if(!connection || !operation.target) {
        return (null); // not connected
    } else {

        // return(<h3>operation: {JSON.stringify(operation)}</h3>);
        if(!operation.action) {
            return (
                <>
                    {bannerBar}

                    <TableDetailsRenderer table={operation.target}  details={metadata} />
                </>
            );
        } else if(operation.action === 'get') {

            return(<>
                {bannerBar}
                <RenderItem />

            </>);

        } else if(operation.action === 'scan' || operation.action === 'query') {  // scan default
            return (
                <>
                    {bannerBar}
                    <ItemsContainer />
                </>
            );
        } else if (operation.action === 'streams') {
            return (<>{bannerBar}<Streams /></>);

        } else {
            return null;
        }
    }
};


const TableDetailsRenderer = (props) => {

    const [{metadata}, ] = useStateValue();
    const [{operation}, ] = useStateValue();
    const t = metadata.Table;

    const mKeys = Object.keys(props.details);

    let displayJson = props.details.Table || null;

    let topName = displayJson  ? displayJson.TableName : null;

    if(operation.index) {
        const inx = t.GlobalSecondaryIndexes.filter(item => item.IndexName === operation.index);

        displayJson = inx[0];
        topName = inx[0].IndexName;
    }

    if((mKeys.length) > 0) {

        return (
            <div>
                <ReactJson src={displayJson} name={topName} theme="rjv-default"  collapsed={2} enableClipboard={false} displayObjectSize={false} displayDataTypes={false}/>
            </div>
        );

    } else {
        return null;
    }


};

export default TableDetailsContainer;

